import primary from '@material-ui/core/colors/blue';
import grey from '@material-ui/core/colors/grey';
import secondary from '@material-ui/core/colors/red';
import { createMuiTheme } from '@material-ui/core/styles';
import update from 'immutability-helper';

/**
 * Theme 가져오기
 * @param {objecT} isDark
 */
const getThemeObject = (isDark = false) => {
  const themeObj = {
    typography: {
      useNextVariants: true,
    },
    palette: {
      primary,
      error: secondary,
      secondary,
      default: grey,
    },
  };
  if (!isDark) {
    return themeObj;
  }
  const themeDarkObj = update(themeObj, {
    palette: { type: { $set: 'dark' } },
  });
  return themeDarkObj;
};

/**
 * Light Theme
 */
export const theme = createMuiTheme(getThemeObject(false));

/**
 * Dark Theme
 */
export const themeDark = createMuiTheme(getThemeObject(true));

// /**
//  * Light Theme 적용
//  * @param {function} Component
//  */
// export const withRoot = Component => props => (
//   <MuiThemeProvider theme={theme}>
//     <Component {...props} />
//   </MuiThemeProvider>
// );

// /**
//  * Dark Theme 적용
//  * @param {function} Component
//  */
// export const withRootDark = Component => props => (
//   <MuiThemeProvider theme={themeDark}>
//     <Component {...props} />
//   </MuiThemeProvider>
// );

// export default withRoot;
